import { Routes } from '@angular/router';
import { revenueManagerGuard } from '../cruise/guards/revenue-manager.guard';
import { bookingOverviewGuard } from '../cruise/guards/booking-overview.guard';
import { revenueManagerResolver } from '../cruise/pages/revenue-manager/revenue-manager.resolver';

export const featureRoutes: Routes = [
  { path: '', redirectTo: '/pages/booking-overview', pathMatch: 'full' },
  {
    path: 'revenue-manager',
    resolve: { items: revenueManagerResolver },
    canActivate: [revenueManagerGuard],
    loadComponent: () =>
      import('../cruise/pages/revenue-manager/revenue-container/revenue-container.component').then(
        (m) => m.RevenueContainerComponent,
      ),
  },
  {
    path: 'booking-overview',
    canActivate: [bookingOverviewGuard],
    loadComponent: () =>
      import('../cruise/pages/booking-overview/booking-overview-page/booking-overview-page.component').then(
        (m) => m.BookingOverviewPageComponent,
      ),
  },
];
